import api from './api';

export interface MetodoPago {
  id: number;
  tipo: 'tarjeta_credito' | 'tarjeta_debito' | 'mercado_pago' | 'google_pay' | 'webpay' | 'khipu' | 'flow';
  apodo?: string;
  banco?: string;
  ultimos_digitos?: string;
  titular?: string;
  mes_expiracion?: string;
  anio_expiracion?: string;
  email_wallet?: string;
  es_principal: boolean;
  verificado: boolean;
  fecha_creacion: string;
  fecha_actualizacion: string;
}

export interface MetodoPagoFormData {
  tipo: 'tarjeta_credito' | 'tarjeta_debito' | 'mercado_pago' | 'google_pay' | 'webpay' | 'khipu' | 'flow';
  apodo?: string;
  banco?: string;
  ultimos_digitos?: string;
  titular?: string;
  mes_expiracion?: string;
  anio_expiracion?: string;
  email_wallet?: string;
  es_principal?: boolean;
  verificado?: boolean;
}

// Obtener todos los métodos de pago del usuario
export const getMetodosPago = async (): Promise<MetodoPago[]> => {
  const response = await api.get('/auth/metodos-pago/');
  // La API puede devolver { results: [...] } o directamente [...]
  const data = response.data;
  return Array.isArray(data) ? data : (data.results || []);
};

// Crear un nuevo método de pago
export const createMetodoPago = async (data: MetodoPagoFormData): Promise<MetodoPago> => {
  const response = await api.post<MetodoPago>('/auth/metodos-pago/', data);
  return response.data;
};

// Actualizar un método de pago
export const updateMetodoPago = async (id: number, data: Partial<MetodoPagoFormData>): Promise<MetodoPago> => {
  const response = await api.patch<MetodoPago>(`/auth/metodos-pago/${id}/`, data);
  return response.data;
};

// Eliminar un método de pago
export const deleteMetodoPago = async (id: number): Promise<void> => {
  await api.delete(`/auth/metodos-pago/${id}/`);
};

// Marcar un método de pago como principal
export const setMetodoPagoPrincipal = async (id: number): Promise<MetodoPago> => {
  const response = await api.post<MetodoPago>(`/auth/metodos-pago/${id}/set_principal/`);
  return response.data;
};

// Obtener etiqueta del método de pago
export const getMetodoPagoLabel = (metodo: MetodoPago): string => {
  switch (metodo.tipo) {
    case 'tarjeta_credito':
      return `Tarjeta de Crédito ${metodo.banco ? `- ${metodo.banco}` : ''} ${metodo.ultimos_digitos ? `****${metodo.ultimos_digitos}` : ''}`;
    case 'tarjeta_debito':
      return `Tarjeta de Débito ${metodo.banco ? `- ${metodo.banco}` : ''} ${metodo.ultimos_digitos ? `****${metodo.ultimos_digitos}` : ''}`;
    case 'mercado_pago':
      return `MercadoPago ${metodo.email_wallet ? `- ${metodo.email_wallet}` : ''}`;
    case 'google_pay':
      return `Google Pay ${metodo.email_wallet ? `- ${metodo.email_wallet}` : ''}`;
    default:
      return 'Método de pago';
  }
};

// Validar método de pago
export const validateMetodoPago = (data: MetodoPagoFormData): { valid: boolean; errors: Record<string, string> } => {
  const errors: Record<string, string> = {};

  if (!data.tipo) {
    errors.tipo = 'El tipo de método de pago es obligatorio';
  }

  if (data.tipo === 'tarjeta_credito' || data.tipo === 'tarjeta_debito') {
    if (!data.ultimos_digitos || data.ultimos_digitos.trim().length === 0) {
      errors.ultimos_digitos = 'Los últimos 4 dígitos son obligatorios';
    }
  }

  if (data.tipo === 'mercado_pago' || data.tipo === 'google_pay') {
    if (!data.email_wallet || data.email_wallet.trim().length === 0) {
      errors.email_wallet = 'El email es obligatorio';
    }
  }

  return {
    valid: Object.keys(errors).length === 0,
    errors
  };
};
